import React from 'react';

import TrackedLink from './TrackedLink';

import { IGaAll } from '../../types';

interface ILinkCardProps {
  children: React.ReactNode;
  ga: IGaAll;
  url: string;
  urlText: string;
}

const LinkCard: React.FC<ILinkCardProps> = ({ children, ga, url, urlText }) => (
  <article className="c-link-card l-pos-rel has-xs-padding has-bg-white-off">
    <div className="c-link-card__content">{children}</div>
    <div className="c-link-card__link l-pos-top l-height-full l-width-full l-pos-abs">
      <TrackedLink
        action={ga.action}
        category={ga.category}
        label={ga.label}
        href={url}
      >
        <span className="is-sr-only">{urlText}</span>
      </TrackedLink>
    </div>
  </article>
);

export default LinkCard;
